.hint {
  display: inline-flex;
  gap: 2px;
  font-family: var(--font-sans);
  font-size: var(--text-xs);
  vertical-align: middle;
}

.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35em;
  height: 1.5em;
  padding: 0 0.35em;
  border: 1px solid var(--border-strong);
  border-bottom-width: 2px;
  border-radius: var(--radius-sm);
  background: var(--surface-2);
  color: var(--text-muted);
  font-family: inherit;
  font-size: inherit;
  line-height: 1;
}
